module.exports = __webpack_public_path__ + "img/msfGame1New.61e88bf1.png";